import utils from "../common/utils";
import store from '../store/store.js'
import api from "../common/api";

export default {

    //解析token
    parseToken: function (token) {
        //检查token有没有过期
        let arr = token.split(".");
        if (!arr[1]) return {};

        let info = utils.base64Decode(arr[1]);
        info = utils.jsonDecode(info);

        return info
    },
    //判断token是否有效
    isTokenValid: function (token) {
        if (this.checkToken(token) === false) {
            store.commit("setBaseInfo", {userId:'',userName:''});
            store.commit("setToken", '');
            localStorage.removeItem(api.TOKEN_NAME);
            return false;
        }

        return true;
    },
    //检查token是否有效
    checkToken: function (token) {
        if (utils.isEmpty(token)) return false;

        let info = this.parseToken(token);

        if (utils.isEmpty(info)) return false;
        if (!info["exp"]) return false;

        //当前时间戳
        let timestamp = parseInt(new Date().getTime() / 1000);

        if (info["exp"] < timestamp) return false;

        store.commit("setBaseInfo", {userId:info['uuid'],userName:info['email']});
        store.commit("setToken", token);

        return info;
    },

    //获取token
    getToken: function () {
        let token = "";
        //从内存直接获取
        if (store.state.token) {
            token = store.state.token;
        }

        //从本地获取
        if (utils.isEmpty(token)) {
            token = localStorage.getItem(api.TOKEN_NAME);
        }

        return token;
    },

    //login in
    setToken:function () {
        let token = utils.getCookie(api.TOKEN_NAME);
        if (!utils.isEmpty(token)) {
            localStorage.setItem(api.TOKEN_NAME, token);
            utils.delCookie(api.TOKEN_NAME);
        }
    }

}
